/**
 * Identity match for a convergent decision-tree edge.
 *
 * A parent may have multiple distinct answers that link to the same child node
 * (convergent edges), so a child reference is uniquely identified by the pair
 * (nodeId, answer) — NOT by nodeId alone. Every remove / edit / reconnect /
 * unlink path that targets a single edge must use this predicate so it acts on
 * exactly one convergent edge rather than all edges to that child.
 *
 * Centralized here so the matching rule (e.g. if answer comparison ever needs to
 * become case-insensitive) changes in one place instead of ~8 call sites.
 */
export const isEdge = (
    child: { nodeId: string; answer: string },
    nodeId: string,
    answer: string
): boolean => child.nodeId === nodeId && child.answer === answer;
